module.exports = __webpack_public_path__ + "static/media/boos-question-start.93a79aed.png";